import { render, staticRenderFns } from "./AccountExtraInfoForm.vue?vue&type=template&id=57bea740&scoped=true&"
import script from "./AccountExtraInfoForm.vue?vue&type=script&lang=js&"
export * from "./AccountExtraInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bea740",
  null
  
)

export default component.exports